module.exports = __webpack_public_path__ + "static/media/shop-category-camper.ad9aedfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/shop-category-camper.svg
// module id = 931
// module chunks = 0